export const hasHorizontalScroll = (element: HTMLDivElement) =>
  element.scrollWidth > element.offsetWidth;

export const hasReachedEnd = (element: HTMLDivElement) => {
  const scrolledWidth = element.scrollLeft + element.clientWidth;

  return scrolledWidth >= element.scrollWidth;
};

export const stopPropagation = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
  event.stopPropagation();

export const setMetaDescription = (description: string): void => {
  document
    .querySelector("meta[name='description']")
    ?.setAttribute("content", description);
};
